import { SectionLabel } from '@reflex/ui/components/layout/Typography';
import { cn } from '@reflex/ui/lib/utils';

type SectionLabelAs = 'h2' | 'h3' | 'h4' | 'span';

interface IconSectionHeaderProps {
  icon: React.ComponentType<{ className?: string }>;
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  /** Merged after default `h-4 w-4 text-muted-foreground` (pass `h-5 w-5` for settings-style headers). */
  iconClassName?: string;
  /** Passed to `SectionLabel` `as` (default `h2`). */
  labelAs?: SectionLabelAs;
  /** Passed to `SectionLabel` `className` (e.g. `font-semibold` for panel subsections). */
  labelClassName?: string;
}

export function IconSectionHeader({
  icon: Icon,
  children,
  action,
  className,
  iconClassName,
  labelAs,
  labelClassName,
}: IconSectionHeaderProps) {
  return (
    <div className={cn('mb-4 flex items-center gap-2', className)}>
      <Icon className={cn('h-4 w-4 text-muted-foreground', iconClassName)} />
      <SectionLabel as={labelAs} className={labelClassName}>
        {children}
      </SectionLabel>
      {action}
    </div>
  );
}
